import * as actionType from "./constants";

const initialState = {
    getAssetAverageConditionIndexesResponse: { isLoading: false, asset_average_condition_indexes: [], count: 0 },
    addAssetAverageConditionIndexResponse: { isLoading: false },
    updateAssetAverageConditionIndexResponse: { isLoading: false },
    deleteAssetAverageConditionIndexResponse: { isLoading: false }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ASSET_CONDITION_INDEX_COLOR_REQUEST:
            return { ...state, getAssetAverageConditionIndexesResponse: { ...state.getAssetAverageConditionIndexesResponse, isLoading: true } };
        case actionType.GET_ASSET_CONDITION_INDEX_COLOR_SUCCESS:
            return {
                ...state,
                getAssetAverageConditionIndexesResponse: {
                    isLoading: false,
                    success: true,
                    asset_average_condition_indexes: [],
                    count: 0,
                    ...action.response
                }
            };
        case actionType.GET_ASSET_CONDITION_INDEX_COLOR_FAILURE:
            return {
                ...state,
                getAssetAverageConditionIndexesResponse: {
                    isLoading: false,
                    success: false,
                    asset_average_condition_indexes: [],
                    count: 0,
                    ...action.error
                }
            };

        case actionType.ADD_ASSET_CONDITION_INDEX_COLOR_REQUEST:
            return { ...state, addAssetAverageConditionIndexResponse: { isLoading: true } };
        case actionType.ADD_ASSET_CONDITION_INDEX_COLOR_SUCCESS:
            return { ...state, addAssetAverageConditionIndexResponse: { isLoading: false, success: true, ...action.response } };
        case actionType.ADD_ASSET_CONDITION_INDEX_COLOR_FAILURE:
            return { ...state, addAssetAverageConditionIndexResponse: { isLoading: false, success: false, ...action.error } };

        case actionType.UPDATE_ASSET_CONDITION_INDEX_COLOR_REQUEST:
            return { ...state, updateAssetAverageConditionIndexResponse: { isLoading: true } };
        case actionType.UPDATE_ASSET_CONDITION_INDEX_COLOR_SUCCESS:
            return { ...state, updateAssetAverageConditionIndexResponse: { isLoading: false, success: true, ...action.response } };
        case actionType.UPDATE_ASSET_CONDITION_INDEX_COLOR_FAILURE:
            return { ...state, updateAssetAverageConditionIndexResponse: { isLoading: false, success: false, ...action.error } };

        case actionType.DELETE_ASSET_CONDITION_INDEX_COLOR_REQUEST:
            return { ...state, deleteAssetAverageConditionIndexResponse: { isLoading: true } };
        case actionType.DELETE_ASSET_CONDITION_INDEX_COLOR_SUCCESS:
            return { ...state, deleteAssetAverageConditionIndexResponse: { isLoading: false, success: true, ...action.response } };
        case actionType.DELETE_ASSET_CONDITION_INDEX_COLOR_FAILURE:
            return { ...state, deleteAssetAverageConditionIndexResponse: { isLoading: false, success: false, ...action.error } };

        default:
            return state;
    }
};
